import CrmServiceModel from "@/models/CrmServiceModel";
import CustomerContactCollection from "@/collections/crm/CustomerContactCollection";
import CustomerLocationCollection from "@/collections/crm/CustomerLocationCollection";

export default class CustomerModel extends CrmServiceModel {

  modelName() {
    return 'customers';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.create = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/public/' + this.modelName();
    routes.exists = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/public/' + this.modelName() + '/exists';
    return routes;
  }

  defaults() {
    return {
      id: null,
      short_name: null,
      full_name: null,
      account_number: null,
      inactive: 0,
      credit: 0,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      customer_contacts: {},
      customer_locations: {}
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      short_name: (val) => (this.nullStringMutator(val)),
      full_name: (val) => (this.nullStringMutator(val)),
      account_number: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getCustomerContacts() {
    return this.getRelatedCollection(new CustomerContactCollection(), 'customer_contacts');
  }

  getCustomerLocations() {
    return this.getRelatedCollection(new CustomerLocationCollection(), 'customer_locations');
  }
}
